import router from '@/router';

export const showHeader = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    isShowHeader: true
  },
  getters: {
    isShowHeader: state => state.isShowHeader
  },
  mutations: {
    show(state) {
      state.isShowHeader = true;
    },
    hide(state) {
      state.isShowHeader = false;
    }
  },
  actions: {
    show({ commit }) {
      commit('show');
    },
    hide({ commit }) {
      commit('hide');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/showHeader.js